module.exports = __webpack_public_path__ + "img/configure-o.e67ff15c.svg";